export function VectorFastIcon({
  height = 16,
  color = '#1A1C1E',
}: {
  height?: number;
  color?: string;
}) {
  return (
    <svg
      width={16 * (height / 16)}
      height={height}
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_421_3156"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill={color} />
      </mask>
      <g mask="url(#mask0_421_3156)">
        <path
          d="M10.0003 13.3333C8.51144 13.3333 7.25033 12.8166 6.21699 11.7833C5.18366 10.75 4.66699 9.48885 4.66699 7.99996C4.66699 6.52218 5.18366 5.26385 6.21699 4.22496C7.25033 3.18607 8.51144 2.66663 10.0003 2.66663C11.4781 2.66663 12.7364 3.18607 13.7753 4.22496C14.8142 5.26385 15.3337 6.52218 15.3337 7.99996C15.3337 9.48885 14.8142 10.75 13.7753 11.7833C12.7364 12.8166 11.4781 13.3333 10.0003 13.3333ZM10.667 7.73329V5.99996C10.667 5.81107 10.6031 5.65274 10.4753 5.52496C10.3475 5.39718 10.1892 5.33329 10.0003 5.33329C9.81144 5.33329 9.6531 5.39718 9.52533 5.52496C9.39755 5.65274 9.33366 5.81107 9.33366 5.99996V8.01663C9.33366 8.10552 9.3531 8.19163 9.39199 8.27496C9.43088 8.35829 9.4781 8.42774 9.53366 8.48329L11.0503 9.99996C11.1837 10.1333 11.342 10.2 11.5253 10.2C11.7087 10.2 11.867 10.1333 12.0003 9.99996C12.1337 9.86663 12.2003 9.70829 12.2003 9.52496C12.2003 9.34163 12.1337 9.18329 12.0003 9.04996L10.667 7.73329ZM2.00033 5.99996C1.81144 5.99996 1.6531 5.93607 1.52533 5.80829C1.39755 5.68052 1.33366 5.52218 1.33366 5.33329C1.33366 5.1444 1.39755 4.98607 1.52533 4.85829C1.6531 4.73052 1.81144 4.66663 2.00033 4.66663H3.33366C3.52255 4.66663 3.68088 4.73052 3.80866 4.85829C3.93644 4.98607 4.00033 5.1444 4.00033 5.33329C4.00033 5.52218 3.93644 5.68052 3.80866 5.80829C3.68088 5.93607 3.52255 5.99996 3.33366 5.99996H2.00033ZM1.33366 8.66663C1.14477 8.66663 0.986437 8.60274 0.858659 8.47496C0.730881 8.34718 0.666992 8.18885 0.666992 7.99996C0.666992 7.81107 0.730881 7.65274 0.858659 7.52496C0.986437 7.39718 1.14477 7.33329 1.33366 7.33329H3.33366C3.52255 7.33329 3.68088 7.39718 3.80866 7.52496C3.93644 7.65274 4.00033 7.81107 4.00033 7.99996C4.00033 8.18885 3.93644 8.34718 3.80866 8.47496C3.68088 8.60274 3.52255 8.66663 3.33366 8.66663H1.33366ZM2.00033 11.3333C1.81144 11.3333 1.6531 11.2694 1.52533 11.1416C1.39755 11.0138 1.33366 10.8555 1.33366 10.6666C1.33366 10.4777 1.39755 10.3194 1.52533 10.1916C1.6531 10.0638 1.81144 9.99996 2.00033 9.99996H3.33366C3.52255 9.99996 3.68088 10.0638 3.80866 10.1916C3.93644 10.3194 4.00033 10.4777 4.00033 10.6666C4.00033 10.8555 3.93644 11.0138 3.80866 11.1416C3.68088 11.2694 3.52255 11.3333 3.33366 11.3333H2.00033Z"
          fill={color}
        />
      </g>
    </svg>
  );
}
